import { z } from 'zod';

// 성별 스키마 - 임시로 string 사용 (Zod v4 API 호환성 문제로 인해)
export const genderSchema = z.string().refine((val) => 
  ['male', 'female', 'other'].includes(val), 
  { message: '올바른 성별을 선택해주세요' }
);

// 연령대 스키마 - 임시로 string 사용 (Zod v4 API 호환성 문제로 인해)
export const ageGroupSchema = z.string().refine((val) => 
  ['teen', 'twenties', 'thirties', 'forties', 'fifties', 'sixties_plus'].includes(val), 
  { message: '올바른 연령대를 선택해주세요' }
);

// 지역 스키마 - 임시로 string 사용 (Zod v4 API 호환성 문제로 인해)
export const regionSchema = z.string().refine((val) => 
  ['seoul', 'busan', 'daegu', 'incheon', 'gwangju', 'daejeon', 'ulsan', 'sejong', 
   'gyeonggi', 'gangwon', 'chungbuk', 'chungnam', 'jeonbuk', 'jeonnam', 
   'gyeongbuk', 'gyeongnam', 'jeju', 'other'].includes(val), 
  { message: '올바른 지역을 선택해주세요' }
);

// 전시회 타입 스키마
export const exhibitionTypeSchema = z.string().refine((val) => 
  ['urbanbreak', 'toycon'].includes(val), 
  { message: '올바른 전시회 타입을 선택해주세요' }
);

// 사전등록 폼 스키마
export const registrationSchema = z.object({
  name: z.string()
    .min(1, '이름을 입력해주세요')
    .min(2, '이름은 2글자 이상 입력해주세요')
    .max(20, '이름은 20글자 이하로 입력해주세요'),
  
  phone: z.string()
    .min(1, '전화번호를 입력해주세요')
    .regex(/^010-?\d{4}-?\d{4}$/, '올바른 전화번호 형식이 아닙니다 (예: 010-1234-5678)'),
  
  email: z.string()
    .min(1, '이메일을 입력해주세요')
    .email('올바른 이메일 형식이 아닙니다'),
    
  nationality: z.string().refine((val) => ['domestic', 'foreigner'].includes(val), {
    message: '국적을 선택해주세요',
  }),
  
  gender: z.string().refine((val) => ['male', 'female', 'other'].includes(val), {
    message: '성별을 선택해주세요',
  }),
  
  age_group: z.string().refine((val) => ['teen', 'twenties', 'thirties', 'forties', 'fifties', 'sixties_plus'].includes(val), {
    message: '연령대를 선택해주세요',
  }),
  
  region: z.string()
    .min(1, '지역을 선택해주세요'),
  
  privacy_consent: z.boolean()
    .refine(val => val === true, {
      message: '개인정보 수집 및 이용에 동의해주세요',
    }),
  
  marketing_consent: z.boolean(),
  
  sms_consent: z.boolean(),
  
  third_party_consent: z.boolean()
    .refine(val => val === true, {
      message: '개인정보 제3자 제공에 동의해주세요',
    }),
  
  exhibition_type: exhibitionTypeSchema,
});

// 타입 추출
export type RegistrationFormData = z.infer<typeof registrationSchema>;

// 에러 메시지 한국어화
export const getErrorMessage = (error: any): string => {
  if (error?.message) {
    return error.message;
  }
  
  // 기본 에러 메시지들
  const defaultMessages: Record<string, string> = {
    'required': '필수 항목입니다',
    'invalid_type': '올바른 형식이 아닙니다',
    'too_small': '입력값이 너무 짧습니다',
    'too_big': '입력값이 너무 깁니다',
    'invalid_string': '올바른 문자열이 아닙니다',
  };
  
  return defaultMessages[error?.code] || '입력값을 확인해주세요';
}; 